import React from 'react';
import PropTypes from 'prop-types';

import { ACTION_NODE_BUTTON, ACTION_NODES, ACTION_TYPE_PRIMARY, ACTION_TYPES } from 'constants/Action';

import { Button as ButtonElem, IconElem } from './Cta.styles';

const Button = ({ children, showIcon, node, styleType, onClick, ...rest }) => (
  <ButtonElem styleType={styleType} onClick={onClick} {...rest} data-test-id={`button-${styleType}`}>
    {children}
    {showIcon && <IconElem icon="arrow-right" />}
  </ButtonElem>
);

Button.propTypes = {
  children: PropTypes.node.isRequired,
  showIcon: PropTypes.bool,
  onClick: PropTypes.func,
  node: PropTypes.oneOf(ACTION_NODES),
  styleType: PropTypes.oneOf(ACTION_TYPES),
};

Button.defaultProps = {
  onClick: () => {},
  showIcon: true,
  node: ACTION_NODE_BUTTON,
  styleType: ACTION_TYPE_PRIMARY,
};

export default Button;
